export default "__VITE_ASSET__BpBWoTnQ__"